/**
 * Webmail portal translations
 */

export const webmail = {
  login: {
    title: 'Webmail Login',
    description: 'Melde dich mit deinem E-Mail-Konto an',
    email: 'E-Mail-Adresse',
    password: 'Passwort',
    submit: 'Anmelden',
    success: 'Erfolgreich angemeldet',
    error: 'Anmeldung fehlgeschlagen',
    backToPortal: 'Zurück zum Portal',
    captchaRequired: 'Bitte bestätige das Captcha.'
  },

  tabs: {
    overview: 'Übersicht',
    vacation: 'Abwesenheit',
    identities: 'Identitäten',
    appPasswords: 'App-Passwörter',
    history: 'Anmeldeverlauf'
  },

  dashboard: {
    subtitle: 'Verwalte dein E-Mail-Postfach',
    loadError: 'Postfach konnte nicht geladen werden'
  },

  delegation: {
    managedDomains: 'Verwaltete Domains',
    managedDomainsHint: 'Du wurdest eingeladen, diese Domains zu verwalten. Klicke auf eine Domain, um Postfächer, Aliase und Mailinglisten zu verwalten.',
    permissions: 'Berechtigungen',
    permissionCount: '{count} Berechtigung | {count} Berechtigungen',
    subtitle: 'Delegierte Domain verwalten',
    notFound: 'Domain nicht gefunden',
    managing: 'Verwaltung',
    noAccess: 'Du hast keinen Zugriff auf diese Domain',
    backToDashboard: 'Zurück zum Dashboard',
    domainField: 'Domain',

    accounts: {
      title: 'E-Mail-Konten',
      create: 'Postfach erstellen',
      errorLoading: 'E-Mail-Konten konnten nicht geladen werden',
      empty: 'Keine E-Mail-Konten gefunden',
      emptyHint: 'Erstelle ein Postfach um loszulegen',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      toggleSuccess: 'Status aktualisiert',
      toggleError: 'Status konnte nicht aktualisiert werden',
      deleteSuccess: 'E-Mail-Konto gelöscht',
      deleteError: 'E-Mail-Konto konnte nicht gelöscht werden',
      deleteTitle: 'E-Mail-Konto löschen',
      deleteConfirm: 'Löschen',
      deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden. Alle E-Mails in diesem Postfach werden dauerhaft gelöscht.',
      delete: 'Löschen',
      columns: {
        email: 'E-Mail',
        type: 'Typ',
        status: 'Status',
        quota: 'Speicherplatz',
        actions: 'Aktionen'
      },
      types: {
        mailbox: 'Postfach',
        alias: 'Alias',
        list: 'Mailingliste',
        shared: 'Geteilt'
      }
    },

    lists: {
      title: 'Mailinglisten',
      create: 'Mailingliste erstellen',
      errorLoading: 'Mailinglisten konnten nicht geladen werden',
      empty: 'Keine Mailinglisten gefunden',
      emptyHint: 'Erstelle eine Mailingliste um loszulegen',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      delete: 'Löschen',
      createTitle: 'Mailingliste erstellen',
      creating: 'Wird erstellt...',
      createSubmit: 'Erstellen',
      createSuccess: 'Mailingliste erstellt',
      createError: 'Mailingliste konnte nicht erstellt werden',
      deleteTitle: 'Mailingliste löschen',
      deleteConfirm: 'Löschen',
      deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden. Die Mailingliste wird dauerhaft gelöscht.',
      deleteSuccess: 'Mailingliste gelöscht',
      deleteError: 'Mailingliste konnte nicht gelöscht werden',
      columns: {
        email: 'E-Mail',
        members: 'Mitglieder',
        externalMembers: 'Externe Mitglieder',
        status: 'Status',
        actions: 'Aktionen'
      },
      fields: {
        name: 'Listenname',
        members: 'Mitglieder',
        membersPlaceholder: "benutzer{'@'}domain.de\nanderer{'@'}domain.de",
        membersHint: 'Eine E-Mail-Adresse pro Zeile, Komma oder Semikolon getrennt',
        externalMembers: 'Externe Mitglieder',
        externalMembersPlaceholder: "extern{'@'}beispiel.de",
        externalMembersHint: 'Externe E-Mail-Adressen (außerhalb dieser Domain)'
      },
      validation: {
        nameRequired: 'Listenname ist erforderlich',
        nameInvalid: 'Nur Buchstaben, Zahlen, Punkte und Bindestriche erlaubt',
        membersRequired: 'Mindestens ein Mitglied ist erforderlich'
      }
    },

    aliases: {
      title: 'Aliase',
      create: 'Alias erstellen',
      errorLoading: 'Aliase konnten nicht geladen werden',
      empty: 'Keine Aliase gefunden',
      emptyHint: 'Erstelle einen Alias um loszulegen',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      delete: 'Löschen',
      createTitle: 'Alias erstellen',
      creating: 'Wird erstellt...',
      createSubmit: 'Erstellen',
      createSuccess: 'Alias erstellt',
      createError: 'Alias konnte nicht erstellt werden',
      deleteTitle: 'Alias löschen',
      deleteConfirm: 'Löschen',
      deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden. Der Alias wird dauerhaft gelöscht.',
      deleteSuccess: 'Alias gelöscht',
      deleteError: 'Alias konnte nicht gelöscht werden',
      edit: 'Bearbeiten',
      editTitle: 'Alias bearbeiten',
      editSubmit: 'Speichern',
      updating: 'Wird gespeichert...',
      updateSuccess: 'Alias aktualisiert',
      updateError: 'Alias konnte nicht aktualisiert werden',
      columns: {
        email: 'E-Mail',
        targets: 'Ziele',
        status: 'Status',
        actions: 'Aktionen'
      },
      fields: {
        name: 'Alias-Name',
        targets: 'Ziele',
        targetsPlaceholder: "benutzer{'@'}domain.de\nanderer{'@'}domain.de",
        targetsHint: 'Eine E-Mail-Adresse pro Zeile, Komma oder Semikolon getrennt',
        active: 'Aktiv'
      },
      validation: {
        nameRequired: 'Alias-Name ist erforderlich',
        nameInvalid: 'Nur Buchstaben, Zahlen, Punkte und Bindestriche erlaubt',
        targetsRequired: 'Mindestens ein Ziel ist erforderlich'
      }
    },

    create: {
      title: 'Postfach erstellen',
      success: 'Postfach erstellt',
      error: 'Postfach konnte nicht erstellt werden',
      creating: 'Wird erstellt...',
      submit: 'Erstellen',
      fields: {
        name: 'Benutzername',
        password: 'Passwort',
        confirmPassword: 'Passwort bestätigen',
        quota: 'Speicherplatz'
      },
      validation: {
        nameRequired: 'Benutzername ist erforderlich',
        nameInvalid: 'Nur Buchstaben, Zahlen, Punkte und Bindestriche erlaubt',
        passwordRequired: 'Passwort ist erforderlich',
        passwordWeak: 'Passwort muss mindestens 8 Zeichen lang sein',
        passwordMismatch: 'Passwörter stimmen nicht überein'
      }
    },

    permissionLabels: {
      'mailbox:read': 'Postfächer anzeigen',
      'mailbox:write': 'Postfächer verwalten',
      'mailbox:delete': 'Postfächer löschen',
      'mailinglist:read': 'Mailinglisten anzeigen',
      'mailinglist:write': 'Mailinglisten verwalten',
      'alias:read': 'Aliase anzeigen',
      'alias:write': 'Aliase verwalten',
      'alias:delete': 'Aliase löschen'
    }
  }
} as const
